import { resourceBaseUrl } from '@/AppSettings';

function InviteIcon() {
    return <img src={`${resourceBaseUrl}/images/Invite.png`} className="h-auto w-fit" alt="interview" />;
}

export default InviteIcon;
